'use client';

import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { useTranslations } from 'next-intl';
import { useRef } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { AppField } from '@/components/forms/AppField';
import { AppForm } from '@/components/forms/AppForm';
import { Close } from '@/components/icons/Close';
import { Search } from '@/components/icons/Search';
import { useRouter } from '@/i18n/navigation';
import { cn } from '@/lib/styles';
const SearchInput = ({
  defaultValue,
  className,
  customOnSearch,
  onInputChange
}: {
  defaultValue?: string;
  className?: string;
  customOnSearch?: (query: string) => void;
  onInputChange?: (query: string) => void;
}) => {
  const t = useTranslations('SearchInput');
  const inputRef = useRef<HTMLInputElement>(null);
  const form = useForm<z.infer<typeof SearchQueryFormSchema>>({
    resolver: standardSchemaResolver(SearchQueryFormSchema),
    defaultValues: {
      query: defaultValue ?? ''
    }
  });
  const router = useRouter();
  const query = form.watch('query');
  const onSearch = (query_0: string) => {
    if (customOnSearch) {
      return customOnSearch(query_0);
    }
    router.push({
      pathname: '/blog/search',
      query: query_0.length > 0 ? {
        s: query_0
      } : {}
    });
  };
  const onSubmit = (values: z.infer<typeof SearchQueryFormSchema>) => onSearch(values.query);
  const handleClear = () => {
    form.setValue('query', '');
    // Focus the input after clearing to maintain focus
    inputRef.current?.focus();
  };
  return <AppForm form={form} onSubmit={onSubmit}
  // biome-ignore lint/suspicious/noConsole: error logging for form validation
  onError={e => console.error(e)} className={cn('w-full', className)}>
      <div className="relative mx-auto w-full">
        <div className="relative group">
          <AppField ref={inputRef} name="query" placeholder={t('placeholder')} fieldClassName="pr-2 h-12 py-3" onInput={e_0 => onInputChange?.(e_0.currentTarget.value)} iconLeft={<button type="button" className="cursor-pointer mt-1.5" name="search-button" onClick={() => {
          form.handleSubmit(onSubmit)();
        }}>
                <Search className="size-3" />
              </button>} hideFormMessage />
          {query.length > 0 && <button type="button" onClick={handleClear} className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer" name="clear-button">
              <Close className="size-3 opacity-50" />
            </button>}
        </div>
      </div>
    </AppForm>;
};
export default SearchInput;
const SearchQueryFormSchema = z.object({
  query: z.string()
});